import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';

import localUtil from '../../lib/util';

@observer
class UserRacesList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
        };
    }

    async componentDidMount() {
        const { raceStore } = this.props.stores;
        await raceStore.loadMyRaces({ showAll: true, limit: 100 });
        this.setState({ loading: false });
    }

    formatTime = (seconds) => {
        if (!seconds || seconds <= 0) return '';
        const h = Math.floor(seconds / 3600);
        const m = Math.floor((seconds % 3600) / 60);
        const s = Math.floor(seconds % 60);
        if (h > 0) {
            return `${h}h ${m}m ${s}s`;
        }
        if (m > 0) {
            return `${m}m ${s}s`;
        }
        return `${s}s`;
    }

    getStatusBadge = (rcc) => {
        const status = rcc.raceStatus;
        if (status === 'DNS') return { text: 'DNS', cls: 'bg-secondary' };
        if (status === 'DNF' || rcc.hasScratched) return { text: 'DNF', cls: 'bg-warning text-dark' };
        if (status === 'DSQ' || status === 'DQ' || rcc.isDisqualified) return { text: 'DSQ', cls: 'bg-danger' };
        if (rcc.isFinished || status === 'OK') return { text: 'Finished', cls: 'bg-success' };
        return { text: 'Signed up', cls: 'bg-info' };
    }

    canDownloadDiploma = (rcc) => {
        return rcc.isFinished || rcc.raceStatus === 'OK';
    }

    render() {
        const { loading } = this.state;
        const { raceStore, userStore } = this.props.stores;
        const { myRaces = [] } = raceStore;
        const { user } = userStore;
        const darkmode = util.getNestedValue(user, 'settings.darkmode');

        if (loading) {
            return (
                <div class='d-flex justify-content-center py-5'>
                    <div class='spinner-border text-primary' role='status'>
                        <span class='visually-hidden'>Loading...</span>
                    </div>
                </div>
            );
        }

        if (!myRaces || myRaces.length === 0) {
            return (
                <div class={`d-flex flex-column align-items-center mt-3 p-4 box-container ${darkmode ? 'bg-darkmode' : 'bg-lightmode'}`}>
                    <i class='fa-duotone fa-flag-checkered text-muted mb-2' style='font-size: 40px;' />
                    <span class='text-muted'><Text id='user.no-races'>No races found</Text></span>
                </div>
            );
        }

        // Sort by date descending (newest first)
        const sorted = [...myRaces].sort((a, b) => {
            const dateA = new Date(a.raceStartDate || a.startTime || a.signupDate || 0);
            const dateB = new Date(b.raceStartDate || b.startTime || b.signupDate || 0);
            return dateB - dateA;
        });

        return (
            <div class='d-flex flex-column gap-2 mt-3'>
                {sorted.map(rcc => {
                    const statusBadge = this.getStatusBadge(rcc);
                    const raceDate = rcc.raceStartDate || rcc.startTime || rcc.signupDate;
                    const canDiploma = this.canDownloadDiploma(rcc);

                    return (
                        <div key={rcc.id} class={`d-flex flex-column p-3 box-container ${darkmode ? 'bg-darkmode' : 'bg-lightmode'}`}>
                            <div class='d-flex flex-row justify-content-between align-items-start'>
                                <div class='d-flex flex-column flex-grow-1'>
                                    <div class='d-flex align-items-center gap-2'>
                                        <strong>{rcc.raceTitle || 'Race'}</strong>
                                        <span class={`badge ${statusBadge.cls}`} style='font-size: 0.7rem;'>{statusBadge.text}</span>
                                    </div>
                                    {rcc.raceClassTitle && (
                                        <small class='text-body-secondary'>{rcc.raceClassTitle}</small>
                                    )}
                                    <div class='d-flex flex-wrap gap-3 mt-1'>
                                        {raceDate && (
                                            <small class='text-body-secondary'>
                                                <i class='fa-regular fa-calendar me-1' />
                                                {util.formatDate(raceDate, { year: 'numeric', month: 'short', day: 'numeric' })}
                                            </small>
                                        )}
                                        {rcc.bib > 0 && (
                                            <small class='text-body-secondary'>
                                                <i class='fa-regular fa-hashtag me-1' />
                                                Bib {rcc.bib}
                                            </small>
                                        )}
                                        {rcc.raceLocation && (
                                            <small class='text-body-secondary'>
                                                <i class='fa-regular fa-location-dot me-1' />
                                                {rcc.raceLocation}
                                            </small>
                                        )}
                                    </div>
                                </div>
                                {canDiploma && (
                                    <a
                                        class='btn btn-sm btn-outline-primary ms-2 flex-shrink-0'
                                        href={`/#/public/race-diploma/${rcc.race}/${rcc.raceClass}/${rcc.id}`}
                                        target='_blank'
                                        rel='noopener noreferrer'
                                    >
                                        <i class='fa-duotone fa-award me-1' />
                                        <Text id='user.diploma'>Diploma</Text>
                                    </a>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}

export default UserRacesList;
